import React from 'react';
import { Link, Button, ButtonProps, LinkProps } from '@material-ui/core';
//import { Link as SPALink } from 'react-router-dom';

interface BaseProps {
    type?: 'link' | 'button';
    spaLink?: boolean;
    buttonClassName?: string;
}

export type IconLinkProps<C extends React.ElementType = 'a'> = BaseProps & Omit<LinkProps<C, { component?: C }>, keyof BaseProps> & Omit<ButtonProps<C, { component?: C }>, keyof BaseProps>

export function IconLink<C extends React.ElementType>({ href, type = 'link', buttonClassName, children, spaLink, ...other }: IconLinkProps<C>): JSX.Element {
    return (<Link
        data-testid='external-link-id'
        underline='none'
        {...other}
        href={href}
        rel='noopener noreferrer'
        target={(href && href.startsWith('#')) ? '_self' : '_blank'}
    >
        {children}
    </Link>
    );
}